import { useQuery } from '@apollo/client'
import { gql } from 'apollo-boost'

export default () => () =>
  useQuery(
    gql`
      query getRunTotals {
        runs {
          id
          name
          mileage
        }

        totalMiles
      }
    `
  )
